<div class="fip-tabs">
  <ng-content></ng-content>
</div>
